<template>
  <div v-if="token_verified" class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6 pl-0 d-none d-sm-flex align-items-center ">
                  <div class="wrap" :style="wrapStyle">
                    <img src="@/assets/img/forgot.jpg" :style="wrapImgStyle" alt="lupa password izidok" />
                  </div>
                </div>
                <div class="col-sm-6 pr-0 d-flex align-items-center">
                  <div>
                    <img src="/img/izidok.baaa69b4.png" alt="izidok"
                      class="img-fluid w-100 d-block float-left logo-forgot" style="width: 39% !important;height:100%;">
                    <div class="mt-3 col-sm-10 form-forgot">
                      <label class="mb-3 mt-4 label-forgot">
                        Masukkan kata sandi Anda untuk dapat melanjutkan akses ke izidok
                      </label>
                      <div>
                        <Form :token="token" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SetPasswordLayout",
    props: ["token"],
    data() {
      return {
        windowHeight: 0,
        token_verified: false,
      };
    },
    components: {
      Form: () => import("./Form.vue"),
    },
    computed: {
      wrapStyle() {
        return {
          height: this.windowHeight + 'px'
        }
      },
      wrapImgStyle() {
        return {
          "max-height": this.windowHeight + 'px'
        }
      },
    },
    beforeMount() {
      this.verify_token();
    }, 
    mounted() {
      this.windowHeight = window.innerHeight;
      this.$nextTick(() => {
        window.addEventListener('resize', (e) => {
          this.windowHeight = window.innerHeight;
        })
      })
    },
    methods: {
      async verify_token() {
        try {
          const res = await this.$axios.get(`verify_token/${this.token}`);
          const {
            status,
            message
          } = res.data;
          if (!status && message == 'Token has replaced!') {
            this.$router.push('/replaced-set-password/');
          } 
          else if (!status && message == 'Token has expired!') {
            this.$router.push('/expired-set-password/');
          }
          else if (!status && message == 'User already active!') {
            this.$router.push('/activated-set-password/');
          }
          else {
            this.token_verified = true;
          }
        } catch (err) {
            this.token_verified = true;
            this.$swal({
              type: "error",
              allowOutsideClick: false,
              title: "Error Verify Token",
              text: err
            }).then((e) => {
              this.$router.push('/login');
            });
        }
      },
    }
  };
</script>

<style scoped>
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin: 0;
  }

  .wrap img {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    min-height: 100%;
    min-width: 100%;
    transform: translate(-50%, -50%);
  }

  .logo-forgot {
    margin-left: 20px;
  }

  .label-forgot {
    margin-top:35px; margin-left:20px ;color:gray
  }
    
  @media only screen and (max-width: 980px) {
    .logo-forgot {
      margin-left: 20px;
    }
  }
</style>